var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 8.00013C6.66667 6.01683 6.88665 4.24526 7.22897 2.99009C7.40143 2.35773 7.59493 1.89418 7.78181 1.60436C7.91551 1.39701 7.99992 1.34467 8.02175 1.3335C11.6864 1.3452 14.6549 4.31373 14.6666 7.97839C14.6555 8.00021 14.6031 8.08463 14.3958 8.21833C14.106 8.4052 13.6424 8.5987 13.01 8.77117C11.7549 9.11348 9.98331 9.33346 8.00001 9.33346C7.55446 9.33346 7.11959 9.32236 6.69887 9.30126C6.67777 8.88054 6.66667 8.44568 6.66667 8.00013Z",
    fill: "#2B2F33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35915 9.19605C4.4558 9.09789 3.65122 8.95151 2.98997 8.77117C2.35761 8.5987 1.89406 8.4052 1.60424 8.21833C1.39689 8.08463 1.34455 8.00021 1.33337 7.97839C1.34324 4.88853 3.45512 2.29355 6.31396 1.54851C6.17386 1.87571 6.05046 2.24383 5.94262 2.63927C5.56108 4.03824 5.33334 5.93334 5.33334 8.00013C5.33334 8.40622 5.34213 8.80568 5.35915 9.19605Z",
    fill: "#2B2F33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45388 10.5462C5.55774 11.6056 5.72521 12.5638 5.94262 13.361C6.05046 13.7564 6.17386 14.1245 6.31395 14.4517C3.98695 13.8453 2.15483 12.0132 1.54839 9.68618C1.87559 9.82627 2.24371 9.94967 2.63914 10.0575C3.43631 10.2749 4.39457 10.4424 5.45388 10.5462Z",
    fill: "#2B2F33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02175 14.6668C11.1116 14.6569 13.7066 12.545 14.4516 9.68618C14.1244 9.82627 13.7563 9.94967 13.3609 10.0575C11.9619 10.4391 10.0668 10.6668 8.00001 10.6668C7.59392 10.6668 7.19446 10.658 6.80408 10.641C6.90224 11.5443 7.04863 12.3489 7.22897 13.0102C7.40143 13.6425 7.59493 14.1061 7.78181 14.3959C7.91551 14.6033 7.99993 14.6556 8.02175 14.6668Z",
    fill: "#2B2F33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.880465dde3ad976a08d70b9c9feef393.svg";
export { ForwardRef as ReactComponent };